'use strict';
/**
 * @author Maxim Seredkin
 */

export default function () {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: true,
        scope: {
            itemsMap: '=?myItemsMap',
            onVisible: '=onVisible',
            selectedItem: '=?myValue',
            items: '=?myItems',
            pagination: '=myPagination',
            loading: '=myLoading',
            search: '=search',
            refresh: '=refresh'
        },
        controllerAs: 'vm',
        controller: ['$scope', '$utils', '$timeout', 'StatusService', 'Notification', '$security', 'OrgService', 'ModalService',
            function ($scope, $utils, $timeout, StatusService, Notification, $security, OrgService, ModalService) {
                $scope.getValue = $utils.getValue;
                $scope.getStatusDisplayName = StatusService.getDisplayName;

                // endregion

                // region Watchers

                // endregion

            }]
    };
}
